module.exports = __webpack_public_path__ + "img/camera.233b67ac.svg";